import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { FollowUpReminder } from '../types/followUp';

export function useFollowUpReminders(contactId: string) {
  const [reminders, setReminders] = useState<FollowUpReminder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchReminders = async () => {
    try {
      const { data, error: fetchError } = await supabase
        .from('nrm_follow_up_reminders')
        .select('*')
        .eq('contact_id', contactId)
        .order('due_date', { ascending: true });

      if (fetchError) throw fetchError;
      setReminders(data || []);
    } catch (err) {
      setError('Failed to load follow-up reminders');
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReminders();
  }, [contactId]);

  const markComplete = async (reminderId: string) => {
    try {
      const { error: updateError } = await supabase
        .from('nrm_follow_up_reminders')
        .update({ 
          completed: true,
          updated_at: new Date().toISOString()
        })
        .eq('id', reminderId);

      if (updateError) throw updateError;
      await fetchReminders();
    } catch (err) {
      console.error('Failed to mark reminder as complete:', err);
    }
  };

  return { reminders, loading, error, refetch: fetchReminders, markComplete };
}